import React from "react";
import { compose } from "redux";
import { Redirect } from "react-router";
import withTranslations from "../../../../../hocs/withTranslations";
import withResetPasswordHandler from "../../../../../hocs/withResetPasswordHandler";
import withUserData from "../../../../../hocs/withUserData";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import Formsy from "formsy-react";
import SquaberLink from "../../../common/SquaberLink";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import { UrlProvider } from "../../../../../api/UrlProvider";
import "../../../auth/authForm.scss";

function ResetPasswordPage({
  formBuilder,
  executeResetPassword,
  userData,
  locale,
  translate
}) {
  if (userData) {
    return <Redirect to={"/"} />;
  }

  const loginTo = UrlProvider.getUrl("fe.login", { locale });

  return (
    <AuthPageLayout
      title={translate("auth_reset-password-page_title")}
      subtitle={translate("auth_reset-password-page_subtitle")}
    >
      <Formsy
        onValidSubmit={() => {
          executeResetPassword(formBuilder.fields);
        }}
      >
        <FormBuilderWeb {...formBuilder} />
        <button
          type={"submit"}
          className={
            "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
          }
        >
          {translate("auth_reset-password-page_submit")}
        </button>
        <p className={"text-sm line-height-100 font-medium text-black-5 mb-8"}>
          {translate("auth_forgot-password-page_remember-password")}{" "}
          <strong className={"font-bold text-black"}>
            <SquaberLink to={loginTo} className={"ml-2"}>
              {translate("auth_forgot-password-page_login-link")}
            </SquaberLink>
          </strong>
        </p>
      </Formsy>
    </AuthPageLayout>
  );
}

export default compose(
  withTranslations,
  withResetPasswordHandler,
  withUserData
)(ResetPasswordPage);
